import React, { FC } from 'react'
import useDeviceSize from 'src/hooks/useDeviceSize'
import ModuleList from 'src/components/Common/MenuModules/components/ModuleList'
import { TfiHelpAlt } from 'react-icons/tfi'
import { Stripe } from 'src/components/Common/MenuModules/components/StripeWrapper'
import { useDispatch, useSelector } from 'react-redux'
import { setClass } from 'src/store/general'
import { State } from 'src/store/rootReducers'
import { useTranslation } from 'react-i18next'
import { IoIosArrowBack } from 'react-icons/io'
import { Category } from 'src/service/api/api.types'
import { Content, Aside, MenuHeader } from './styles'
import { ButtonFloat } from './components/StripeWrapper/styles'

interface Props {
  category: Category
}

const MenuModules: FC<Props> = ({ category }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [width] = useDeviceSize()
  const stateMenu = useSelector((state: State) => state.general.classMenu)

  const isMobile = width <= 768
  const mustShow = !isMobile || stateMenu
  const wantClass = mustShow ? 'open' : 'close'
  const handleHamburger = () => isMobile && dispatch(setClass())

  React.useEffect(() => {
    if (stateMenu) {
      document.body.classList.add('stop-scrolling')
    }
    return () => document.body.classList.remove('stop-scrolling')
  }, [stateMenu])
  return (
    <MenuHeader className={`menu-module ${wantClass} ${isMobile && !stateMenu ? 'hidden' : ''}`}>
      <Content className={mustShow ? 'mobile' : ''}>
        <ButtonFloat onClick={() => dispatch(setClass())}>
          <IoIosArrowBack />
        </ButtonFloat>
        <Aside>
          <Stripe
            title={category.title}
            hasIcon={false}
            imageUrl={category.iconUrl}
            hasButton
            onClick={handleHamburger}
          />
          <Stripe
            id="help_item"
            title={t('classes.help')}
            hasLink
            hasIcon
            href="#helper"
            Icon={TfiHelpAlt}
            preset="secondary"
          />

          <ModuleList modules={category.modules} />
        </Aside>
      </Content>
    </MenuHeader>
  )
}
export default MenuModules
